<template>
  <v-card class="mx-auto form-card-padding text-center">
    <template v-if="setup.length == 0">
      <div>
        {{ $t('components.charts.loading') }}
      </div>
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
        center
      ></v-progress-circular>
    </template>

    <apexchart v-if="setup.length != 0" :options="options" :series="options.series"></apexchart>
  </v-card>
</template>

<script>
import apexchart from 'vue-apexcharts'

export default {
  components: { apexchart },
  name: 'SalesByCountry',

  props: {
    setup: Array
  },
  watch: {
    setup: {
      deep: true,
      handler () {
        let seriesData = []
        let countriesData = []

        this.setup.forEach(function (n) {
          seriesData.push(n.count)
          countriesData.push(n.country)
        })

        this.options.series[0].data = seriesData
        this.options.xaxis.categories = countriesData

        this.options = { ...this.options }
      }
    }
  },
  data () {
    return {
      options: {
        series: [
          {
            name: this.$t('dashboard.salesByCountry.title'),
            data: []
          }
        ],
        chart: {
          type: 'bar',
          height: 380
        },
        plotOptions: {
          bar: {
            barHeight: '100%',
            distributed: true,
            horizontal: true,
            dataLabels: {
              position: 'bottom'
            }
          }
        },
        colors: [
          '#33b2df',
          '#546E7A',
          '#d4526e',
          '#13d8aa',
          '#A5978B',
          '#2b908f',
          '#f9a3a4',
          '#90ee7e',
          '#f48024',
          '#69d2e7'
        ],
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          style: {
            colors: ['#fff']
          },
          formatter: function (val, opt) {
            return opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
          },
          offsetX: 0,
          dropShadow: {
            enabled: true
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        xaxis: {
          categories: []
        },
        yaxis: {
          labels: {
            show: false
          }
        },
        title: {
          text: this.$t('dashboard.salesByCountry.title'),
          align: 'center',
          floating: true
        },
        subtitle: {
          text: this.$t('dashboard.salesByCountry.subtitle'),
          align: 'center'
        },
        tooltip: {
          theme: 'dark',
          x: {
            show: false
          },
          y: {
            title: {
              formatter: function () {
                return ''
              }
            }
          }
        }
      }
    }
  }
}
</script>
